module.exports = __webpack_public_path__ + "img/1440.b554df14.jpg";